/**
 * @packageDocumentation
 * @module HackerAPI.User.Gender
 */
/**
 * @enum string
 */
var Gender;
(function (Gender) {
    /**
     * @returns
     */
    Gender["MALE"] = "male";
    /**
     * @returns
     */
    Gender["FEMALE"] = "female";
    /**
     * @returns
     */
    Gender["PREFER_NOT_TO_SPECIFY"] = "prefer_not_to_specify";
    /**
     * @returns
     */
    Gender["OTHER"] = "other";
})(Gender || (Gender = {}));
export default Gender;
//# sourceMappingURL=gender.js.map